/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import "./Loader.css";

export const Loader = ({ isLoading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      const progressInterval = setInterval(() => {
        const increment = (100 - progress) / 20;
        // console.log("isLoading", isLoading, "progress", progress, "increment", increment);

        setProgress(progress < 100 ? progress + increment : 0);
      }, 50);
      return () => clearInterval(progressInterval);
    }
  }, [isLoading, progress]);

  return (
    <div className={`loader-bar${isLoading ? " active" : ""}`}>
      <div className="loader-bar-progress" style={{ width: `${progress}%` }}></div>
    </div>
  );
};
